"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HeaderHelper = /** @class */ (function () {
    function HeaderHelper() {
        /**
        * Header name for SDK usage
        */
        this.sdkVersionHeader = 'X-KC-SDKID';
    }
    /**
    * Header identifying SDK type & version for internal purposes of Kentico
    */
    HeaderHelper.prototype.getSdkIdHeader = function (info) {
        return {
            header: this.sdkVersionHeader,
            value: info.host + ";" + info.name + ";" + info.version
        };
    };
    return HeaderHelper;
}());
exports.HeaderHelper = HeaderHelper;
exports.headerHelper = new HeaderHelper();
//# sourceMappingURL=header.helper.js.map